module.exports = __webpack_public_path__ + "static/img/12.577d7dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/12.png
// module id = h2rX
// module chunks = 0